import React, { useEffect } from 'react';
import '../MobileOptimization.css';

const MobileOptimization = () => {
  useEffect(() => {
    // 모바일 환경에서 더블 탭 줌 방지
    document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });

    // 핀치 줌 방지
    document.addEventListener('touchmove', function(event) {
      if (event.scale !== 1) {
        event.preventDefault();
      }
    }, { passive: false });

    // 화면 방향 변경 감지
    const handleOrientationChange = () => {
      const orientationWarning = document.querySelector('.orientation-warning');
      if (orientationWarning) {
        if (window.orientation === 90 || window.orientation === -90) {
          orientationWarning.style.display = 'flex';
        } else {
          orientationWarning.style.display = 'none';
        }
      }
    };

    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return (
    <div className="orientation-warning">
      <div>📱</div>
      <p>세로 모드로 전환해주세요</p>
      <p>게임은 세로 모드에 최적화되어 있습니다</p>
    </div>
  );
};

export default MobileOptimization;
